<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid" />Tournaments
      </slot>
      <div class="float-right">
        <router-link :to="{ name: 'TournamentCreate'}">
          <button class="btn btn-success">Create Tournament</button>
        </router-link>
      </div>
    </CCardHeader>
    <CCardBody>
      <v-client-table :data="tournaments" :columns="columns" :options="options">
        <template slot="gratification_status" slot-scope="props">
          <div>
              <span>
                <CBadge v-if="props.row.gratification_status=='Completed'" color="success">Completed</CBadge>
                <CBadge v-else color="warning">Pending</CBadge>
              </span>
          </div>
        </template>
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="{ name: 'TournamentEdit', params: {id: props.row.id}}">
              <span
                  class="btn btn-warning btn-sm m-1"
                  data-toggle="tooltip"
                  title="Edit"
                  :href="props.row.id"
              >
                <CIcon name="cil-pencil" size="sm" />
              </span>
            </router-link>
            <router-link :to="{ name: 'TournamentRanking', params: {id: props.row.id}}">
              <span
                  class="btn btn-secondary btn-sm m-1"
                  data-toggle="tooltip"
                  title="See Ranking"
                  :href="props.row.id"
              >
                <CIcon name="cil-list" size="sm" />
              </span>
            </router-link>
            <router-link :to="{ name: 'TournamentQuestions', params: {id: props.row.id}}">
              <span
                  class="btn btn-behance btn-sm m-1"
                  data-toggle="tooltip"
                  title="See Questions"
                  :href="props.row.id"
              >
                <CIcon name="cil-calculator" size="sm" />
              </span>
            </router-link>
            <span @click="handleDelete(props.row.id)"
                  class="btn btn-danger btn-sm m-1"
                  data-toggle="tooltip"
                  title="Delete"
                  :href="props.row.id"
            >
                <CIcon name="cil-basket" size="sm" />
              </span>
          </div>
        </template>
      </v-client-table>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "Tournaments",
  data() {
    return {
      tournaments: [],
      columns: ["id", "name", "partner_name","tournament_type", "start_time", "end_time", "duration", "fee","gratification_status", "action"],
      options: {
        pagination: {nav: "fixed"},
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    }
  },
  created() {
    this.getTournaments();
  },
  methods: {
    getTournaments() {
      this.$axios
          .get(`${ADMIN_URL}/tournaments`)
          .then((response) => {
            this.tournaments = response.data;
            this.tournaments.forEach(function (element) {
              element.gratification_status =(element.prize_count == element.prize_given_count)? 'Completed':'Pending';
            });
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    handleDelete(id) {
      // console.log('handleDelete  category_id === ', category_id);
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      }).then(result => {
        if(result.value) {
          this.deleteTournament(id);
        }
      }).catch(error => {
        //console.log('Sweetalert ERROR');
      });
    },
    deleteTournament(id)
    {
      this.$axios
          .delete(`${ADMIN_URL}/tournaments/${id}`)
          .then((response) => {
            this.$swal("Success", response.data.message, "success");
            this.getTournaments()
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            this.$swal("Error", error.response.message, "error");
          });
    }
  }
}
</script>

<style scoped>

</style>
